import Grid from '@mui/material/Grid';
import { getDomainConfig } from '@raisin/cp-utils';
import React, { memo } from 'react';
import { CustomLink } from '../../../../components/CustomLink';
import { resolveUrlWithLocale } from '../../../../utils/helpers';
import * as S from './styles';
const ContentLinks = memo(({ footerLinks, locale }) => {
    const { basePath } = getDomainConfig(locale);
    return footerLinks.length ? (React.createElement(S.GridContainer, { maxWidth: "xl" },
        React.createElement(Grid, { container: true, spacing: 3 }, footerLinks.map((section) => {
            var _a;
            return (React.createElement(Grid, { item: true, key: section === null || section === void 0 ? void 0 : section.heading, xs: 12, md: 3 },
                React.createElement(S.Heading, null, section === null || section === void 0 ? void 0 : section.heading), (_a = section.link) === null || _a === void 0 ? void 0 :
                _a.map((link) => (React.createElement(CustomLink, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath), key: link === null || link === void 0 ? void 0 : link.title },
                    React.createElement(S.Anchor, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath) }, link === null || link === void 0 ? void 0 : link.title))))));
        })))) : null;
});
ContentLinks.displayName = 'ContentLinks';
export default ContentLinks;
//# sourceMappingURL=index.js.map